import { number, object } from 'yup'

export const GlobalSchema = object().shape({
  changeMarketCap: number(),
  changeVolume: number(),
  dominanceBTC: number(),
  marketCap: number(),
  volume: number(),
})
